import React, { useState, useCallback } from "react";
import uploadimg from "../../assets/images/uploadimg.png";
import scenerywhite from "../../assets/images/scenery-grey.png";
import scenerygrey from "../../assets/images/scenery-white.png";

const UploadModal = ({ currentIndex, onImageChange,currentSKU,map_valueSet,versionValue,isVariantImageUploading,setVersionValue,setCurrentIndex }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadType, setUploadType] = useState("indiviual");
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;

  // File selection from input
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
    }
    onImageChange(file,currentIndex,currentSKU);
  };

  // Drag and drop
 const handleDrop = useCallback((e) => {
  e.preventDefault();
  const file = e.dataTransfer.files?.[0];
  onImageChange(file, currentIndex, currentSKU);

  if (file) {
    setSelectedFile(file);
  }
}, [currentIndex, currentSKU, onImageChange]);

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleUploadClick = () => {
    if (selectedFile && onImageChange && versionValue && !isVariantImageUploading) {
      map_valueSet(currentIndex,versionValue,"image")
      map_valueSet(currentIndex,uploadType,"imgType")
      // setCurrentIndex(null);
      setSelectedFile(null);
      setUploadType('indiviual')
    }
  };
const handleCancelClick=()=>{
  // map_valueSet(currentIndex,"indiviual","imgType");
  // map_valueSet(currentIndex,"","image")
  setSelectedFile(null);
  setUploadType('indiviual')
   setCurrentIndex(null);

}
  const canUpload = Boolean(selectedFile && versionValue && !isVariantImageUploading);

  return (
    <div
      className="modal fade modal1-width"
      id="uploadModal"
      tabIndex={-1}
      aria-labelledby="uploadModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal1-border">
          <div className="modal-header modal1-header">
            <h5 className="modal-title modal1-title" id="uploadModalLabel">
              Upload Image for Variant
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={()=>handleCancelClick()}
            ></button>
          </div>
          <div className="upload-type">
            <label className="upload-header">Choose upload type</label>
            <div className="form-check mb-2 radioclass">
              <input
                className="form-check-input"
                type="radio"
                name="uploadType"
                id="uploadTypeDifferent"
                value="indiviual"
                checked={uploadType === "indiviual"}
                onChange={(e) => setUploadType(e.target.value)}
              />
              <label className="upload-header-1" htmlFor="uploadTypeDifferent">
                Use different images for each variant
              </label>
            </div>

            <div className="form-check radioclass">
              <input
                className="form-check-input"
                type="radio"
                name="uploadType"
                id="uploadTypeSame"
                value="same"
                checked={uploadType === "same"}
                onChange={(e) => setUploadType(e.target.value)}
              />
              <label className="upload-header-1" htmlFor="uploadTypeSame">
                Use the same image for all variant
              </label>
            </div>
          </div>

          <div className="modal-body">
            <div
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              className={`upload-body text-center ${selectedFile?"flexclass":""}`}
              style={{
                borderStyle: "dashed",
                cursor: "pointer",
                backgroundColor: "#f8f9fa",
              }}
              onClick={() => document.getElementById("upload-input").click()}
            >
              {selectedFile ? (
                <div className="imgdiv">
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="preview"
                    className="img-fluid mb-2 imgheight"
                  />
                  {/* <div>{selectedFile.name}</div> */}
                </div>
              ) : (
                <>
                  <div className="imgdiv">
                    <img className={selectedFile?"":"whclass"} src={uploadimg} alt="uploadimg" />
                  </div>
                  <div className="drop-text">
                    Drop your image here or{" "}
                    <span className="browse-span">browse file</span>
                  </div>
                  <div className="filesizetext">
                    Maximum File Size: 25 MB •  File Format: JPG or PNG
                  </div>
                </>
              )}

              <input
                type="file"
                id="upload-input"
                accept="image/png, image/jpeg"
                onChange={handleFileChange}
                hidden
              />
            </div>
            {selectedFile && (
              <div className="uploadedimg">
                <div className="uploaded-left">
                  <img
                    src={scenerygrey}
                    alt="scenerygrey"
                  />
                  <div className="uploadedimgname">{selectedFile.name}</div>
                  <div className="uploadedimgname">
                    ({(selectedFile.size / 1024).toFixed(2)} KB)
                  </div>
                </div>
                <img
                  src={base_assets + "images/pos/icons/delete-icon.png"}
                  alt="delete-icon"
                  onClick={() => setSelectedFile(null)}
                ></img>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn-cancel"
              data-bs-dismiss="modal"
              onClick={()=>handleCancelClick()}
            >
              Cancel
            </button>
            <button
              type="button"
              className={canUpload ? "btn-upload" : "btn-upload-disabled"}
              onClick={handleUploadClick}
              data-bs-dismiss={canUpload ? "modal" : undefined}
              disabled={!canUpload}
            >
              {canUpload ? (
                <img
                  src={scenerywhite}
                  alt="scenerygrey"
                  style={{ height: "12px", width: "16.25px" }}
                />
              ) : (
                <img
                  src={scenerygrey}
                  alt="scenerywhite"
                  style={{ height: "12px", width: "16.25px" }}
                />
              )}
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadModal;
